export default "__VITE_ASSET__DFVIkC9f__"